import {Component, EventEmitter, forwardRef, HostBinding, Input, ViewChild} from '@angular/core';
import {IOption, SelectComponent} from 'ng-select';
import {isArray, isNullOrUndefined} from 'util';
import {ModelListener} from '../../../../../common/components/model-listener';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {template} from 'lodash';
import {DictionaryObject} from '../../../../../common/api';

const VALUE_ACCESSOR_PROVIDER: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectFilterComponent),
    multi: true
};

@Component({
    selector: 'tfl-select-filter',
    template: `
        <ng-select
            *ngIf="innerOptions"
            [options]="innerOptions"
            [placeholder]="placeholder | translate"
            [disabled]="disabled"
            (selected)="onSelectOption($event)"
        ></ng-select>
    `,
    providers: [VALUE_ACCESSOR_PROVIDER]
})
export class SelectFilterComponent<T extends DictionaryObject> extends ModelListener {

    @Input() placeholder = '';
    @Input() disabled = false;

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();
    innerOptions: IOption[];

    @ViewChild(SelectComponent) ngSelect: SelectComponent;

    private optionsMap: Map<IOption, T>;
    private _optionTmplCompiler;

    @Input('optionTmpl')
    set optionTemplate(tmpl: string) {
        this._optionTmplCompiler = template(tmpl);
    }

    @Input('options')
    set setOptions(options: T[]) {
        if (isArray(options)) {
            this.setInnerOptions(options);
        }
    }

    @HostBinding('attr.disabled')
    get disabledAttr() {
        return this.disabled ? 'disabled' : null;
    }

    writeValue(val: T): void {
        if (!isNullOrUndefined(val)) {
            this.selectOptionByValue(val);
        }
    }

    onSelectOption(option: IOption) {
        this.onChange.emit(this.optionsMap.get(option));
    }

    private selectOptionByValue(newValue: T) {
        if (this.ngSelect) {
            this.optionsMap.forEach((value, option) => {
                if (newValue === value) {
                    this.ngSelect.select(option.value);
                }
            });
        }
    }

    private setInnerOptions(options) {
        this.optionsMap = new Map();
        this.innerOptions = [];
        options.map(o => {
            const optionLabel = o.label || o.name || '';
            const newOption = {
                value: o.value || o.id,
                label: this._optionTmplCompiler ? this._optionTmplCompiler(o) : optionLabel
            };
            this.optionsMap.set(newOption, o);
            this.innerOptions.push(newOption);
        });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/elements/select/select-filter.component.ts